import React from 'react';
import { useBreadcrumb } from '../contexts/BreadcrumbContext';
import Breadcrumb from '../components/Breadcrumb';

export default function OurStory() {
  const { setItems } = useBreadcrumb();

  React.useEffect(() => {
    setItems([
      { label: 'Home', path: '/' },
      { label: 'Our Story', path: '/our-story' }
    ]);
  }, [setItems]);

  return (
    <div className="min-h-screen bg-cotton">
      <div className="container mx-auto px-4 py-8">
        <Breadcrumb />

        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-dm-serif text-mulch mb-6">Our Story</h1>

          <section className="bg-white rounded-lg shadow-sm p-8 mb-8">
            <h2 className="text-3xl font-dm-serif text-mulch mb-4">Meet the Founder</h2>
            <h3 className="text-xl text-spring-leaf font-medium mb-4">Erin Blohm</h3>

            <div className="mb-6">
              <img
                src="https://blooma-images.s3.us-east-2.amazonaws.com/site_images/SSP_8372+(1).jpg"
                alt="Erin Blohm, Founder of Blooma"
                className="float-left mr-6 mb-4 w-full md:w-1/2 h-auto rounded-lg shadow-md"
              />
            </div>

            <div className="space-y-4 text-mulch font-dm-sans">
              <p>
                Gardening has always been a part of my life. Some of my earliest memories are picking peas in my grandpa's vegetable garden, looking up at the towering corn stalks as I munched away at the pods. Then I'd wander over to my grandma's flower garden. When she told me all the names of the blooms I'd nod in awe (how did she remember all those fancy names?!)
              </p>
              <p>
                As I got older, gardening was still part of my life. I found myself tasked with the chore of helping my mom in our sprawling home garden (not really what you want to be doing in your teenage summer years). But even as an angsty teenager, I found peace in the sun, picking beans and helping to prepare the soil for new growth.
              </p>
              <p>
                Fast forward a number of years, and my husband and I bought our first house in the city. And while a small yard was on our house-hunting wishlist; the handful of raised garden beds that came with it weren't. We welcomed our first daughter that winter, and in the following few summers I found joy in dipping my toes back into gardening and recreating those same fond memories with my daughter. (Ever see a 2 year old pull carrots out of the ground the size of her head? Nothing is better). My love of gardening was reignited, and it became my solace in between my computer-filled day job in technology and the hustle and bustle of the city.
              </p>
              <p>
                In 2021, we made an unexpected move to Northern Michigan where we were met with a bit more land — and a total blank slate for our garden. We poured ourselves into creating a space where we could grow food for our growing family, and my love for gardening blossomed into a full blown obsession (the good kind!). I wanted everyone to experience the joy and connection with nature that gardening brought to me.
              </p>
              <p>
                Meanwhile, I found myself spending so. much. time. scouring the internet, social media, and other resources for information and planning tools to make growing my garden easier and more enjoyable. Everything I found was antiquated and fragmented, and overwhelmed me and left me feeling more confused than when I started.
              </p>
              <p>
                So Blooma was born. A one-stop resource designed to make gardening more accessible, enjoyable, and communal wherever you live. Because gardening is more than just growing something. It's a way of connecting with nature, with others, and with yourself. And it's just too good not to share.
              </p>
            </div>
          </section>

          <section className="bg-white rounded-lg shadow-sm p-8">
            <h2 className="text-2xl font-dm-serif text-mulch mb-6">Our Values</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-primary-50 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-mulch mb-2">Accessibility</h3>
                <p className="text-mulch font-dm-sans">
                  We believe gardening should be for everyone. Blooma is designed to make growing a garden accessible regardless of space, experience, or budget.
                </p>
              </div>
              <div className="bg-primary-50 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-mulch mb-2">Sustainability</h3>
                <p className="text-mulch font-dm-sans">
                  We promote sustainable gardening practices that work with nature, not against it. We put an emphasis on organic methods, water conservation, and soil health.
                </p>
              </div>
              <div className="bg-primary-50 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-mulch mb-2">Community</h3>
                <p className="text-mulch font-dm-sans">
                  Gardening is better together. We foster a supportive community where gardeners can share knowledge, celebrate successes, and learn from challenges.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
